import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/home/Footer';

import styles from './styles/Legal.module.css';

const PrivacyPolicy = () => {
    return (
        <div className={styles.legalContainer}>
            <div className={styles.legalHeader}>
                <Link to="/" className={styles.logoLink}>
                    <img
                        src="/icons/android-icon-192x192.png"
                        alt="JetChats Logo"
                        className={styles.logo}
                    />
                </Link>
                <h1>Privacy Policy</h1>
                <p>Last updated: {new Date().toLocaleDateString()}</p>
            </div>

            <div className={styles.legalContent}>
                <section>
                    <h2>1. Introduction</h2>
                    <p>Welcome to JetChats. We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our service.</p>
                    <p>Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the service.</p>
                </section>

                <section>
                    <h2>2. Information We Collect</h2>
                    <p>We collect several types of information from and about users of our service, including:</p>
                    <h3>2.1 Personal Data</h3>
                    <p>While using our service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. This may include:</p>
                    <ul>
                        <li>Email address</li>
                        <li>First and last name</li>
                        <li>Phone number (optional)</li>
                        <li>Address, State, Province, ZIP/Postal code, City (optional)</li>
                        <li>Payment information (for subscription services)</li>
                    </ul>

                    <h3>2.2 Usage Data</h3>
                    <p>We may also collect information about how the service is accessed and used. This Usage Data may include:</p>
                    <ul>
                        <li>Your computer's Internet Protocol address (e.g., IP address)</li>
                        <li>Browser type and version</li>
                        <li>The pages of our service that you visit</li>
                        <li>The time and date of your visit</li>
                        <li>The time spent on those pages</li>
                        <li>Unique device identifiers and other diagnostic data</li>
                    </ul>

                    <h3>2.3 Tracking & Cookies Data</h3>
                    <p>We use cookies and similar tracking technologies to track activity on our service and hold certain information. Cookies are files with small amounts of data which may include an anonymous unique identifier.</p>
                    <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our service.</p>
                </section>

                <section>
                    <h2>3. How We Use Your Information</h2>
                    <p>We use the information we collect for various purposes, including to:</p>
                    <ul>
                        <li>Provide and maintain our service</li>
                        <li>Notify you about changes to our service</li>
                        <li>Allow you to participate in interactive features of our service when you choose to do so</li>
                        <li>Provide customer support</li>
                        <li>Gather analysis or valuable information so that we can improve our service</li>
                        <li>Monitor the usage of our service</li>
                        <li>Detect, prevent and address technical issues</li>
                        <li>Process payments and prevent fraud</li>
                    </ul>
                </section>

                <section>
                    <h2>4. Legal Basis for Processing Personal Data</h2>
                    <p>We may process your Personal Data because:</p>
                    <ul>
                        <li>We need to perform a contract with you</li>
                        <li>You have given us permission to do so</li>
                        <li>The processing is in our legitimate interests and it's not overridden by your rights</li>
                        <li>To comply with the law</li>
                    </ul>
                </section>

                <section>
                    <h2>5. Retention of Data</h2>
                    <p>We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our legal agreements and policies.</p>
                    <p>We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our service, or we are legally obligated to retain this data for longer time periods.</p>
                </section>

                <section>
                    <h2>6. Transfer of Data</h2>
                    <p>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.</p>
                    <p>If you are located outside the United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to the United States and process it there.</p>
                    <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>
                </section>

                <section>
                    <h2>7. Disclosure of Data</h2>
                    <h3>7.1 Business Transaction</h3>
                    <p>If JetChats is involved in a merger, acquisition or asset sale, your Personal Data may be transferred. We will provide notice before your Personal Data is transferred and becomes subject to a different Privacy Policy.</p>

                    <h3>7.2 Disclosure for Law Enforcement</h3>
                    <p>Under certain circumstances, JetChats may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g., a court or a government agency).</p>

                    <h3>7.3 Legal Requirements</h3>
                    <p>JetChats may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
                    <ul>
                        <li>Comply with a legal obligation</li>
                        <li>Protect and defend the rights or property of JetChats</li>
                        <li>Prevent or investigate possible wrongdoing in connection with the service</li>
                        <li>Protect the personal safety of users of the service or the public</li>
                        <li>Protect against legal liability</li>
                    </ul>
                </section>

                <section>
                    <h2>8. Security of Data</h2>
                    <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>

                    <h3>8.1 Data Protection Mechanisms</h3>
                    <p>To protect sensitive data, we implement several security measures, including:</p>
                    <ul>
                        <li>Encryption of data in transit using TLS/SSL protocols</li>
                        <li>Encryption of sensitive data at rest</li>
                        <li>Regular security audits and vulnerability assessments</li>
                        <li>Access controls and authentication requirements for all systems containing user data</li>
                        <li>Regular security training for all staff with access to user data</li>
                        <li>Implementation of data minimization principles</li>
                        <li>Strict vendor management procedures for any third parties with potential access to user data</li>
                    </ul>
                </section>

                <section>
                    <h2>9. Third-Party Services and API Data Usage</h2>
                    <p>When you connect JetChats to third-party services and APIs, we handle your data with the utmost care:</p>
                    <ul>
                        <li>We only access data necessary for the functioning of our service and only with your explicit consent</li>
                        <li>We do not use data obtained through third-party APIs for advertising purposes</li>
                        <li>We do not sell or share your data from third-party services with other parties except as necessary to provide our service</li>
                        <li>We maintain the confidentiality and security of all third-party data in accordance with our security practices described in this policy</li>
                        <li>We only retain data from third-party services for as long as necessary to provide our service to you</li>
                    </ul>

                    <h3>9.1 Google Workspace API Data</h3>
                    <p>Specifically regarding Google Workspace APIs, we explicitly affirm that data obtained through Google Workspace APIs is not used to develop, improve, or train generalized AI and/or machine learning models.</p>
                </section>

                <section>
                    <h2>10. Your Data Protection Rights</h2>
                    <p>Depending on your location, you may have certain rights regarding your personal information, such as:</p>
                    <ul>
                        <li>The right to access, update or delete the information we have on you</li>
                        <li>The right of rectification - the right to have your information corrected if it is inaccurate or incomplete</li>
                        <li>The right to object - the right to object to our processing of your Personal Data</li>
                        <li>The right of restriction - the right to request that we restrict the processing of your personal information</li>
                        <li>The right to data portability - the right to be provided with a copy of your Personal Data in a structured, machine-readable and commonly used format</li>
                        <li>The right to withdraw consent - the right to withdraw your consent at any time where we relied on your consent to process your personal information</li>
                    </ul>
                    <p>Please note that we may ask you to verify your identity before responding to such requests.</p>
                </section>

                <section>
                    <h2>11. Service Providers</h2>
                    <p>We may employ third-party companies and individuals to facilitate our service ("Service Providers"), to provide the service on our behalf, to perform service-related services or to assist us in analyzing how our service is used.</p>
                    <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>
                </section>

                <section>
                    <h2>12. Analytics</h2>
                    <p>We may use third-party Service Providers to monitor and analyze the use of our service.</p>
                    <p>For example, we may use Google Analytics, which is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network.</p>
                </section>

                <section>
                    <h2>13. Payments</h2>
                    <p>We may provide paid products and/or services within the service. In that case, we use third-party services for payment processing (e.g., payment processors).</p>
                    <p>We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy.</p>
                </section>

                <section>
                    <h2>14. Links to Other Sites</h2>
                    <p>Our service may contain links to other sites that are not operated by us. If you click on a third-party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>
                    <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third-party sites or services.</p>
                </section>

                <section>
                    <h2>15. Children's Privacy</h2>
                    <p>Our service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If you are a parent or guardian and you are aware that your child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.</p>
                </section>

                <section>
                    <h2>16. Changes to This Privacy Policy</h2>
                    <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
                    <p>We will let you know via email and/or a prominent notice on our service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.</p>
                    <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
                </section>

                <section>
                    <h2>17. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, please contact us at privacy@jetchats.com.</p>
                </section>
            </div>

            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
